import React from 'react'
import ReactDOM from 'react-dom'


interface ModalProps {
  children: React.ReactNode,
  isOpen: boolean,
  portalDivName: string
  minHeight?: string,
  minWidth?: string
}

const Modal = ({children, isOpen, portalDivName, minHeight, minWidth}: ModalProps) => {

  const rootDiv = document.getElementById(`${portalDivName}`) as HTMLDivElement

  if (!rootDiv) {
    throw new Error(`Portal element with id '${portalDivName}' not found`)
  }

  if (!isOpen) return null 
  
  const h = minHeight || "45svh"
  const w = minWidth || "40svw"

  return ReactDOM.createPortal(
    <div className="fixed top-0 left-0 w-full h-full bg-black/60 flex justify-center items-center z-[1000]">
      <div className="flex flex-col justify-between items-center bg-gray-200 p-1 rounded-md">
        <div className={`min-w-[${w}] min-h-[${h}] flex items-center justify-center bg-black rounded-md`}>
          {children}
        </div>
      </div>
    </div>,
    document.getElementById(`${portalDivName}`) as HTMLDivElement
  )
}

export default Modal